import React from "react";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";
import EmailStatusIcon from "./EmailIcons";
import {
  getSummaryParts,
  getPrimarySummaryStatus,
  getStatusColor,
  hasSummaryData,
} from "../utils/emailAutomationHelpers";
import "./EmailAutomationRow.css";

const EmailAutomationRow = ({ summary, onClick }) => {
  if (!hasSummaryData(summary)) return null;

  const primaryStatus = getPrimarySummaryStatus(summary);
  const parts = getSummaryParts(summary);

  return (
    <div
      className="job-info-row email-automation-row"
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <span className="job-info-label">Email Automation</span>
      <span className="job-info-value email-automation-value">
        <EmailStatusIcon
          status={primaryStatus}
          size={0.7}
          color={getStatusColor(primaryStatus)}
        />
        <span className="email-automation-summary-text">
          {parts.map((part, index) => (
            <React.Fragment key={part.text}>
              {index > 0 && (
                <span className="email-automation-separator"> · </span>
              )}
              <span style={{ color: part.color }}>{part.text}</span>
            </React.Fragment>
          ))}
        </span>
        <Icon
          path={mdiChevronRight}
          size={0.8}
          className="email-automation-chevron"
        />
      </span>
    </div>
  );
};

export default EmailAutomationRow;
